import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["type"],
      _excluded2 = ["message", "intl"],
      _excluded3 = ["type", "messageKeys", "messages"];
import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
const StyledLi = styled.li.withConfig({
  displayName: "BasicList__StyledLi",
  componentId: "sc-1cecik2-0"
})(["margin-bottom:0.4em;color:", ";"], props => props.theme.palette.text.hint);

const ListContainer = _ref => {
  let {
    type
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return type === 'ordered' ? /*#__PURE__*/React.createElement("ol", props) : /*#__PURE__*/React.createElement("ul", props);
};

const ListItem = _ref2 => {
  let {
    message,
    intl
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(StyledLi, null, /*#__PURE__*/React.createElement(Typography, _extends({
    component: "span",
    color: "textPrimary"
  }, props), intl.formatMessage(message)));
};
/**
 * @component
 * Basic, un-nested styled list. Pass messageKeys array to limit which  messages are
 * rendered.
 */


export const BasicList = _ref3 => {
  let {
    type = 'ordered',
    messageKeys,
    messages
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  const intl = useIntl();
  const keys = messageKeys || Object.keys(messages);
  return /*#__PURE__*/React.createElement(ListContainer, _extends({
    type: type
  }, props), keys.map(key => /*#__PURE__*/React.createElement(ListItem, _extends({
    key: key,
    intl: intl,
    message: messages[key]
  }, props))));
};
export default BasicList;